/** Only abc media */
if (vocento.config.nibara.media === 'abc') {
  (function (d, s, id, token) {
    let js, djs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement("script");
    js.id = id;
    js.async = 1;
    js.src = "//rrss.abc.es/pixel/js/" + token;
    djs.parentNode.insertBefore(js, djs);
  }(document, 'script', 'dogtrack-app', "ABCES"));
}



// WEBPACK FOOTER //
// ./src/tracking/dogtrack.js